import { makeStyles, shorthands } from '@fluentui/react-components';

export const useLinkRefenceStyles = makeStyles({
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    ...shorthands.padding('0px'),
    ...shorthands.margin('-1px'),
    ...shorthands.overflow('hidden'),
    ...shorthands.border('0px'),
  },
});
